import { Link } from "@tanstack/react-router";
import { CartDrawer } from "@/components/cart-drawer";

const links = [
  { label: "Perfumes", to: "/products", hash: undefined },
  { label: "How It Works", to: "/how-it-works", hash: undefined },
  { label: "Field Notes", to: "/field-notes", hash: undefined },
  { label: "About", to: "/about", hash: undefined },
];

export function PageHeader() {
  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/85 py-4 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6">
        <nav className="hidden flex-1 items-center gap-8 md:flex">
          {links.slice(0, 2).map((l) => (
            <Link
              key={l.label}
              to={l.to}
              hash={l.hash}
              className="eyebrow text-foreground/70 transition-colors hover:text-gold"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/" className="flex flex-col items-center leading-none" aria-label="House of Apocrypha — Home">
          <span className="font-[var(--font-logo)] text-[0.65rem] tracking-[0.35em] text-gold uppercase">
            House of
          </span>
          <span className="font-[var(--font-logo)] text-xl tracking-[0.18em] text-parchment uppercase sm:text-2xl">
            Apocrypha
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-end gap-8 md:flex">
          {links.slice(2).map((l) => (
            <Link
              key={l.label}
              to={l.to}
              hash={l.hash}
              className="eyebrow text-foreground/70 transition-colors hover:text-gold"
            >
              {l.label}
            </Link>
          ))}
          <CartDrawer />
        </nav>
        <div className="md:hidden">
          <CartDrawer />
        </div>
      </div>
    </header>
  );
}
